import React, { useEffect, useRef } from "react";
import {
  TextContainer,
  Paragraph,
  Link,
} from "../styles/components/Global/Text";
import animations from "./Animations";

const LinkParagraphSecondary = () => {
  const containerRef = useRef(null);
  useEffect(() => {
    animations.parallax(containerRef.current);
  }, []);
  return (
    <TextContainer ref={containerRef} $align="flex-end" $flex>
      <Paragraph $textAlign="left" $width="medium" $bold={true} $indent={true}>
        The audio-element of the piece is scored by Arek Krupiński, meticulously
        crafted to align with the company's brand progression, particularly
        fitting as it coincides with the brand's 75th anniversary celebration.
        The visual storyline commences with a vintage low-resolution game
        aesthetic and evolves into futuristic, technology-inspired visuals,
        mirroring the{" "}
        <a
          href="https://www.lotuscars.com/eletre?utm_source=editorial23&utm_medium=PARTNERWEBSITE&utm_campaign=ELETRE_NA_Influencer_Q3_23&utm_content=HS-editorial"
          target="_blank"
        >
          Lotus Eletres
        </a>
        ’ innovative features—electric propulsion, remarkable speed, and
        aerodynamics.
      </Paragraph>
    </TextContainer>
  );
};

export default LinkParagraphSecondary;
